import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { Product } from "../../models/product.model";
import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import { StbCustomRenderButtonComponent } from "../smart-table-customs/custom-render-button";

@Component({
  selector: "ngx-view-table-products",
  styleUrls: ["./view-table-products.component.scss"],
  templateUrl: "./view-table-products.component.html",
})
export class ViewTableProductsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = "units"; //product.mode
  @Input() products?: Product[] = [];
  @Output() onSelectedProduct: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";

  //ng2-smart-table config
  source: LocalDataSource = new LocalDataSource();
  settings = {
    hideHeader: true,
    noDataMessage: "Không có dữ liệu",
    actions: {
      columnTitle: "",
    },
    selectMode: "multi",
    pager: {
      display: true,
      perPage: 50,
    },
    add: {
      confirmCreate: true,
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      confirmSave: true,
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      confirmDelete: true,
      deleteButtonContent: '<i class="nb-trash"></i>',
    },

    columns: {
      title: {
        title: "Tên sản phẩm",
        type: "string",
      },
      // title: {
      //   title: "Tên sản phẩm",
      //   type: "html",
      //   editor: {
      //     type: "custom",
      //     component: StbCustomEditorProductTitleComponent,
      //   },
      // },
      unitName: {
        title: "ĐVT",
        width: "100px",
        filter: false,
        type: "string",
      },
      price: {
        title: "Giá bán",
        width: "100px",
        filter: false,
        type: "custom",
        renderComponent: StbCustomRenderNumberComponent,
      },
      // button: {
      //   title: "",
      //   width: "100px",
      //   filter: false,
      //   type: "custom",
      //   renderComponent: StbCustomRenderButtonComponent,
      //   onComponentInitFunction(instance) {
      //     instance.onSelected.subscribe((row) => {
      //       console.log("onSelected:", row);
      //       alert(`${row.title} saved!`);
      //     });
      //   },
      // },
    },
  };

  constructor(
    private userService: UserService,
    private productService: ProductService,
    private router: Router,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          this.source.load(this.products);
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //smart-table events
  onCreateConfirm(event): void {
    console.log("onCreateConfirm:", event);
    const title = event.newData.title;
    const price = event.newData.price;
    const unitName = event.newData.unitName;
    if (title.length > 0 && price > 0) {
      let prod = new Product();
      prod.title = title;
      prod.price = price;
      prod.unitName = unitName;
      prod.shopId = this.shopId;

      this.loading = true;
      this.submitted = true;

      this.productService
        .create(prod)
        .then((data) => {
          event.newData["id"] = data.id;
          event.newData["title"] = title;
          event.newData["price"] = price;
          event.newData["unitName"] = unitName;
          event.confirm.resolve(event.newData);

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          event.confirm.reject();
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  onSaveConfirm(event) {
    const id = event.data.id;
    const title = event.newData.title;
    const price = event.newData.price;
    const costPrice = event.newData.costPrice;
    const unitName = event.newData.unitName;
    if (title.length > 0 && price > 0) {
      this.loading = true;
      this.submitted = true;

      this.productService
        .updatePrice(this.shopId, id, title, unitName, price, costPrice)
        .then((data) => {
          event.newData["title"] = title;
          event.newData["price"] = price;
          event.confirm.resolve(event.newData);

          this.loading = false;
          this.submitted = false;

          //sync data to offline DB
          let item = event.newData;
          this.productService.sync(item);
        })
        .catch((err) => {
          event.confirm.reject();
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  onDeleteConfirm(event): void {
    console.log("onDeleteConfirm:", event);
    const id = event.data.id;
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.productService
            .delete(this.shopId, id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              //sync data to offline DB
              let item = event.data;
              item.isDeleted = true;
              this.productService.sync(item);

              event.confirm.resolve();
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
              event.confirm.reject();
            });
        } else {
          event.confirm.reject();
        }
      });
  }

  selectedProduct(event): void {
    // console.log("selectedProduct:", event);
    const item = event.data;
    // this.dialogService
    //   .open(DialogYesNoPromptComponent, {
    //     context: {
    //       title: `Chọn mặt hàng: ${item.title}?`,
    //       // description: `Giá: ${item.price.toLocaleString()} vnđ`,
    //     },
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //       this.onSelectedProduct.emit(item);
    //     }
    //   });

    this.onSelectedProduct.emit(event.selected);

    if (event.selected) {
      event.isSelected = false;
    }
  }
}
